module.exports = __webpack_public_path__ + "static/media/turkdunyasi.cd153055.jpg";